import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
    request.get('/api/v4ward/energy/meter/warnset/page', Object.assign({}, options, { params }));

export const getMeterModelList = (params, options) =>
    request.get('/api/v4ward/iot/device/meterModelList', Object.assign({}, options, { params }));

export const getMeterTree = (params, options) =>
    request.get('/api/v4ward/iot/device/meterTree', Object.assign({}, options, { params }));

export const getModelParams = (params, options) =>
    request.get('/api/v4ward/energy/meter/warnset/modelParams', Object.assign({}, options, { params }));


    export const warnsetSave = (data) =>
    request.post('/api/v4ward/energy/meter/warnset/save',data);

    
    export const warnsetUpdate = (data) =>
    request.post('/api/v4ward/energy/meter/warnset/update',data);

    export const warnsetRemove = (params, options) =>
    request.post('/api/v4ward/energy/meter/warnset/remove', qs.stringify(params),options);


    export const warnsetDetail = (params,options) =>
    request.get('/api/v4ward/energy/meter/warnset/detail',Object.assign({}, options, { params }));


    // /v4ward/energy/meter/warnset/detail

// export const getDetail = (params, options) =>
// request.get('/api/v4ward/energy/meter/model/detail', Object.assign({}, options, { params }));

// export const remove = (params, options) =>
// request.post('/api/v4ward/energy/meter/model/remove', qs.stringify(params),options);

// export const add = (params, options) =>
// request.post('/api/v4ward/energy/meter/model/save', params,options);

// export const update = (params, options) =>
// request.post('/api/v4ward/energy/meter/model/update', params,options);

// export const stop = (params, options) =>
// request.post('/api/v4ward/energy/meter/model/updateStatus', qs.stringify(params),options);


// // 获取仪表参数下拉框数据
// export const getParamsList = (params, options) =>
// request.get('/api/v4ward/energy/meter/param/getEnergyMeterParamListByMeasuringUnit', Object.assign({}, options, { params }));


// //通过仪表参数获取其他数据
// export const getParamsByparamId = (params, options) =>
// request.get('/api/v4ward/energy/meter/param/detail', Object.assign({}, options, { params }));



// //获取详情
// export const getParamsDetailById = (params, options) =>
// request.get('/api/v4ward/energy/meter/model/param/getMeterModelParamListByModelId', Object.assign({}, options, { params }));